import { isRedoHotKey, isUndoHotKey } from '@/sharedComponents/TextEditor/commands/hotkeys';
import { EXTERNAL_REDO_BUTTON_ID, EXTERNAL_UNDO_BUTTON_ID } from '@/sharedComponents/TextEditor/constants';
import isActiveElementInputField from '@/sharedComponents/TextEditor/utils/isActiveElementInputField';
import { useDreamEditorRef } from '@typedream/dream-editor';
import { focusEditor, isEditorFocused, select } from '@udecode/plate-core';
import { useEffect } from 'react';

function UndoRedoComponent() {
  const editor = useDreamEditorRef();
  function onUndo() {
    try {
      if (!isEditorFocused(editor)) {
        focusEditor(editor);
        if (!editor.selection) {
          select(editor, [0, 0]);
        }
      }
      editor.undo();
    } catch (_) {
      // do nothing
    }
  }
  function onRedo() {
    try {
      if (!isEditorFocused(editor)) {
        focusEditor(editor);
        if (!editor.selection) {
          select(editor, [0, 0]);
        }
      }
      editor.redo();
    } catch (_) {
      // do nothing
    }
  }

  // Handle undo and redo when editor is not focused
  if (typeof document !== 'undefined') {
    useEffect(() => {
      function onKeyUndo(e: KeyboardEvent) {
        if (isUndoHotKey(e) && !isEditorFocused(editor) && !isActiveElementInputField()) {
          onUndo();
        }
      }
      document.addEventListener('keydown', onKeyUndo);
      return () => {
        document.removeEventListener('keydown', onKeyUndo);
      };
    }, []);

    useEffect(() => {
      document.getElementById(EXTERNAL_UNDO_BUTTON_ID)?.addEventListener('click', onUndo);
      return () => {
        document.getElementById(EXTERNAL_UNDO_BUTTON_ID)?.removeEventListener('click', onUndo);
      };
    }, [document.getElementById(EXTERNAL_UNDO_BUTTON_ID)]);

    useEffect(() => {
      function onKeyRedo(e: KeyboardEvent) {
        if (isRedoHotKey(e) && !isEditorFocused(editor) && !isActiveElementInputField()) {
          onRedo();
        }
      }
      document.addEventListener('keydown', onKeyRedo);
      return () => {
        document.removeEventListener('keydown', onKeyRedo);
      };
    }, []);

    useEffect(() => {
      document.getElementById(EXTERNAL_REDO_BUTTON_ID)?.addEventListener('click', onRedo);
      return () => {
        document.getElementById(EXTERNAL_REDO_BUTTON_ID)?.removeEventListener('click', onRedo);
      };
    }, [document.getElementById(EXTERNAL_REDO_BUTTON_ID)]);
  }
  return <></>;
}

export default UndoRedoComponent;
